export default __webpack_public_path__ + "static/media/IF_MyTeamStrengths_StrengthDesc_04.77a6c7b5.jpg";